export default __webpack_public_path__ + "static/media/migration-1.610f6f1c.jpg";